import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StatistikProduktivitetFormlerModal } from '../statistik-produktivitet-formler-modal/statistik-produktivitet-formler-modal';

@Component({
    selector: 'app-statistik-options-formler',
    templateUrl: './statistik-options-formler.component.html',
    standalone: false
})
export class StatistikOptionsFormlerComponent {
    constructor(private ngbModal: NgbModal) { }

    openFormlerModal() {
        this.ngbModal.open(StatistikProduktivitetFormlerModal);
    }
}
